import attache3 from '../attache/attache3.pdf'
import attache2 from '../attache/OfficeSpace.pptx'
import attache4 from '../attache/cibus.pdf'
import veganFriendly from '../images/veganFriendly.png'

function RenderContent({ content, searchTerm }) {
  const parseContent = (text) => {
    const linkPattern = /\[(.*?)\]\((.*?)\)/g // For [text](link)
    const boldPattern = /\*\*(.*?)\*\*/g // For **bold** text
    const newlinePattern = /(\n)/g // For newlines
    const logoPattern = /\{logo\}/g // Matches "{logo}"

    const highlightPattern = searchTerm
      ? new RegExp(`(${searchTerm})`, 'gi')
      : null

    const parts = []
    let patterns = [
      { regex: linkPattern, type: 'link' },
      { regex: logoPattern, type: 'logo' },
    ]

    let match, nextMatch, nextType
    let sortedMatches = []

    // Find all matches for both patterns
    patterns.forEach(({ regex, type }) => {
      while ((match = regex.exec(text)) !== null) {
        sortedMatches.push({ match, type })
      }
    })

    // Sort matches by their index
    sortedMatches.sort((a, b) => a.match.index - b.match.index)

    let lastIndex = 0

    sortedMatches.forEach(({ match, type }) => {
      if (lastIndex < match.index) {
        // Add text before the match
        parts.push(text.slice(lastIndex, match.index))
      }

      if (type === 'link') {
        let href
        if (match[2] === '#pdf-attache3') {
          href = attache3
        } else if (match[2] === '#pdf-attache2') {
          href = attache2
        } else if (match[2] === '#pdf-attache4') {
          href = attache4
        } else {
          href = match[2]
        }

        // Add the link
        parts.push(
          <a
            key={match.index}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {match[1]}
          </a>
        )
      } else if (type === 'logo') {
        // Add the logo image
        parts.push(
          <img
            key={`logo-${match.index}`}
            src={veganFriendly}
            alt="Vegan Friendly Logo"
            className="inline_img"
            style={{ width: '50px', height: '50px' }}
          />
        )
      }

      // Update lastIndex to the end of the current match
      lastIndex = match.index + match[0].length
    })

    // Add any remaining text
    if (lastIndex < text.length) {
      parts.push(text.slice(lastIndex))
    }

    // ////////////////////////////

    // const processedParts = []
    // parts.forEach((part, i) => {
    //   if (typeof part === 'string') {
    //     let lastIndex = 0
    //     let match

    //     while ((match = logoPattern.exec(part)) !== null) {
    //       // Add any text before the `{logo}` placeholder
    //       if (lastIndex < match.index) {
    //         processedParts.push(part.slice(lastIndex, match.index))
    //       }

    //       // Replace `{logo}` with the image
    //       processedParts.push(
    //         <img
    //           key={`logo-${i}-${match.index}`}
    //           src={veganFriendly}
    //           alt="Vegan Friendly Logo"
    //           style={{ width: '50px', height: '50px', marginLeft: '8px' }}
    //         />
    //       )

    //       lastIndex = logoPattern.lastIndex
    //     }

    //     // Add any remaining text after the last `{logo}`
    //     if (lastIndex < part.length) {
    //       processedParts.push(part.slice(lastIndex))
    //     }
    //   } else {
    //     processedParts.push(part) // Preserve non-string components like links
    //   }
    // })

    const applyHighlightAndBold = (text, i, j) => {
      const boldPattern = /\*\*(.*?)\*\*/g
      const result = []
      let lastIndex = 0
      let match

      while ((match = boldPattern.exec(text)) !== null) {
        // Add plain text before the bold match
        if (lastIndex < match.index) {
          result.push(
            applyHighlight(text.slice(lastIndex, match.index), i, j, lastIndex)
          )
        }

        // Add bold text, then apply highlight within it
        result.push(
          <strong key={`bold-${i}-${j}-${match.index}`}>
            {applyHighlight(match[1], i, j, match.index)}
          </strong>
        )

        lastIndex = boldPattern.lastIndex
      }

      // Add the remaining plain text
      if (lastIndex < text.length) {
        result.push(applyHighlight(text.slice(lastIndex), i, j, lastIndex))
      }

      return result
    }

    const applyHighlight = (text, i, j, offset) => {
      if (!highlightPattern) return text

      const highlightedLine = text.split(highlightPattern).map((segment, k) =>
        segment.toLowerCase() === searchTerm.toLowerCase() ? (
          <span key={`${i}-${j}-${offset}-${k}`} className="highlighted_text">
            {segment}
          </span>
        ) : (
          segment
        )
      )

      return highlightedLine
    }

    const result = []
    let currentList = null

    parts.forEach((part, i) => {
      if (typeof part === 'string') {
        const splitByNewline = part.split(newlinePattern)

        splitByNewline.forEach((line, j) => {
          const trimmedLine = line.trim()

          if (trimmedLine.startsWith('•')) {
            if (!currentList) {
              currentList = []
              result.push(<ul key={`ul-${i}-${j}`}>{currentList}</ul>)
            }

            currentList.push(
              <li key={`li-${i}-${j}`}>
                {applyHighlightAndBold(trimmedLine.substring(1).trim(), i, j)}
              </li>
            )
          } else {
            if (line) {
              result.push(
                <span key={`${i}-${j}`}>
                  {applyHighlightAndBold(line, i, j)}
                </span>
              )
            } else {
              result.push(<br key={`${i}-${j}`} />)
            }

            currentList = null
          }
        })
      } else {
        result.push(part)
      }
    })

    return result
  }

  const parseBoldText = (text, i, j) => {
    const boldPattern = /\*\*(.*?)\*\*/g
    const result = []
    let lastIndex = 0
    let match

    while ((match = boldPattern.exec(text)) !== null) {
      if (lastIndex < match.index) {
        result.push(text.slice(lastIndex, match.index))
      }

      result.push(
        <strong key={`bold-${i}-${j}-${match.index}`}>{match[1]}</strong>
      )

      lastIndex = boldPattern.lastIndex
    }

    if (lastIndex < text.length) {
      result.push(text.slice(lastIndex))
    }

    return result
  }

  return <div>{parseContent(content)}</div>
}

export default RenderContent
